import { render, staticRenderFns } from "./OilCompany.vue?vue&type=template&id=1c4f6f2e&scoped=true&"
import script from "./OilCompany.vue?vue&type=script&lang=js&"
export * from "./OilCompany.vue?vue&type=script&lang=js&"
import style0 from "./OilCompany.vue?vue&type=style&index=0&id=1c4f6f2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f6f2e",
  null
  
)

export default component.exports